import {ListItemIcon} from "@mui/material";
import React from "react";
import {useLocation, useNavigate} from "react-router";
import {MenuContext} from "../AppMenu";
import StyledListItemButton from "./common/StyledListItemButton";
import StyledListItemText from "./common/StyledListItemText";

const AppMenuNestedLink = ({ children, icon, to = "" }) => {
  const { toggleIsMenuOpen } = React.useContext(MenuContext);
  const navigate = useNavigate();
  const clickHandler = () => {
    toggleIsMenuOpen();
    navigate(to);
  };

  const location = useLocation();

  return (
    <StyledListItemButton
      onClick={clickHandler}
      sx={{ paddingLeft: 4 }}
      className={location.pathname === to ? "active" : ""}
    >
      {Boolean(icon) && (
        <ListItemIcon sx={{ color: "inherit" }}>
          {React.cloneElement(icon, {
            fontSize: "small",
            size: "small",
            sx: { color: "inherit" },
          })}
        </ListItemIcon>
      )}
      <StyledListItemText secondary={children} />
    </StyledListItemButton>
  );
};

export default AppMenuNestedLink;
